export default __webpack_public_path__ + "static/media/389.9f14b332.jpg";